/**
 * Requests json from a server
 * @param url The URL to request
 * @param method The method to use to request
 * @param body The body
 */
export function request<T, R>(
  url: string,
  method: string,
  body?: T
): Promise<R> {
  return new Promise((resolve, reject) => {
    const opts: RequestInit = {
      method,
    };
    if (body) {
      opts.body = JSON.stringify(body);
    }
    try {
      window
        .fetch(url, opts)
        .then((res) => {
          if (!res.ok) {
            return reject(res.status);
          } else {
            res
              .json()
              .then((body) => {
                resolve(body);
              })
              .catch(reject);
          }
        })
        .catch(reject);
    } catch (err) {
      reject(err);
    }
  });
}
